import { useQuery } from "@tanstack/react-query";
import { getRequestByAuth } from "../../../function/helper";
import { useState } from "react";

const useVipAccess = () => {
  const [hasVipAccess, setVipAccess] = useState(null);

  const { data, isFetching } = useQuery({
    queryKey: ["get-vip-access"],
    queryFn: () =>
      getRequestByAuth("/users-access/v1/getVipAccess").then(res => {
        if (res && res.status === 200) {
          setVipAccess(true);
          return res.list;
        }

        setVipAccess(false);
        return null;
      }),

    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: 0,
    retryOnMount: true,
    refetchInterval: true,
  });

  const hasFinancialOrder = financialOrderEnumItem => {
    if (!data) {
      return false;
    }

    return data.find(item => item === financialOrderEnumItem) ? true : false;
  };

  return { hasVipAccess, hasFinancialOrder, loading: isFetching };
};

export default useVipAccess;
